import { Line } from 'react-chartjs-2';

const simulationScores = {
  labels: ['Q1', 'Q2', 'Q3', 'Q4'],
  datasets: [{
    label: 'Performance Score',
    data: [75, 82, 88, 85],
    borderColor: 'rgb(79, 70, 229)',
    tension: 0.4,
  }],
};

const identifiedGaps = [
  { area: 'Communication', severity: 'high', status: 'in-progress' },
  { area: 'Response Time', severity: 'medium', status: 'completed' },
  { area: 'Tool Usage', severity: 'low', status: 'planned' },
  { area: 'Team Coordination', severity: 'medium', status: 'in-progress' },
];

export default function SimulationResults() {
  return (
    <div className="space-y-6 mt-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-medium mb-4">Recent Drill Metrics</h3>
          <div className="h-64">
            <Line data={simulationScores} />
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-medium mb-4">Identified Gaps</h3>
          <div className="space-y-4">
            {identifiedGaps.map((gap) => (
              <div key={gap.area} className="flex items-center justify-between">
                <div>
                  <h4 className="font-medium">{gap.area}</h4>
                  <span
                    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                      gap.severity === 'high'
                        ? 'bg-red-100 text-red-800'
                        : gap.severity === 'medium'
                        ? 'bg-yellow-100 text-yellow-800'
                        : 'bg-green-100 text-green-800'
                    }`}
                  >
                    {gap.severity}
                  </span>
                </div>
                <span
                  className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                    gap.status === 'completed'
                      ? 'bg-green-100 text-green-800'
                      : gap.status === 'in-progress'
                      ? 'bg-blue-100 text-blue-800'
                      : 'bg-gray-100 text-gray-800'
                  }`}
                >
                  {gap.status}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-medium mb-4">Remediation Progress</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="border rounded-lg p-4">
            <h4 className="font-medium text-gray-900">High Priority</h4>
            <div className="mt-2">
              <p className="text-2xl font-bold text-red-600">75%</p>
              <p className="text-sm text-gray-500">Resolution rate</p>
            </div>
            <div className="mt-2">
              <span className="text-sm text-gray-600">2 items remaining</span>
            </div>
          </div>
          <div className="border rounded-lg p-4">
            <h4 className="font-medium text-gray-900">Medium Priority</h4>
            <div className="mt-2">
              <p className="text-2xl font-bold text-yellow-600">85%</p>
              <p className="text-sm text-gray-500">Resolution rate</p>
            </div>
            <div className="mt-2">
              <span className="text-sm text-gray-600">3 items remaining</span>
            </div>
          </div>
          <div className="border rounded-lg p-4">
            <h4 className="font-medium text-gray-900">Low Priority</h4>
            <div className="mt-2">
              <p className="text-2xl font-bold text-green-600">92%</p>
              <p className="text-sm text-gray-500">Resolution rate</p>
            </div>
            <div className="mt-2">
              <span className="text-sm text-gray-600">1 item remaining</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}